import HeaderCustomerSearchProfileComponent from "@/app/components/routes/auth_routes/CustomerProfile/SearchCustomer/Header";
import SearchResultTableComponent from "@/app/components/routes/auth_routes/CustomerProfile/SearchCustomer/SearchResultTable";
import { useSearchCustomerAPI } from "@/app/hooks/api_hooks/customer_profile/useSearchCustomerAPI";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useRouter } from "@/app/hooks/useRouter";
import { ICustomerProfileState } from "@/app_redux/reducers/slices/auth/customer_profile_slice";
import React from "react";
import { ICustomerProfileSearchPageProps } from "./interface";
export interface IClientProfile {
  name: string;
}

const CustomerProfileSearchPage: React.FC<ICustomerProfileSearchPageProps> = (_props) => {
  const { getRouteKey } = useRouter();
  const { routeState } = useRouteInfo(getRouteKey("CUSTOMER_PROFILE", "id"));
  const { customerSearchResults, searchCustomerQuery } = routeState.state as ICustomerProfileState;
  const { execute: searchCustomer } = useSearchCustomerAPI();

  return (
    <div>
      <div>
        <HeaderCustomerSearchProfileComponent searchCustomer={searchCustomer as any} />
      </div>
      <div className="w-full h-full px-2">
        <SearchResultTableComponent data={customerSearchResults} hasSearched={!!searchCustomerQuery} />
      </div>
    </div>
  );
};

export default CustomerProfileSearchPage;
